import { createSlice } from "@reduxjs/toolkit";
import CommonUtil from "../../util/CommonUtils";

const initialState = {
  provision: {},
  currentFunctionKey: {},
  shiftId: 0,
  dateTimeInMs: Date.now(),
  employeeShift: [],
  customMappingData: {
    customV1: "",
    customV2: "",
    customV3: "",
    customV4: "",
    customV5: "",
    customV6: "",
    customV7: "",
    customV8: "",
    customV9: "",
    customV10: "",
  },
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    updateProvision(state, action) {
      const data = action.payload;
      if (!CommonUtil.isEmpty(data)) {
        state.provision = data;
      }
    },

    updateCurrentFunctionKey(state, action) {
      state.currentFunctionKey = action.payload;
    },

    updateCustomMappingData(state, action) {
      const updatedData = action.payload;

      if (!CommonUtil.isEmpty(updatedData)) {
        Object.entries(updatedData).forEach(([key, value]) => {
          if (state.customMappingData[key] !== value) {
            state.customMappingData[key] = value;
          }
        });
      }
    },

    storeShiftId(state, action) {
      state.shiftId = action.payload;
    },

    resetShiftId(state) {
      state.shiftId = 0;
    },

    storeDateAndTimeInMS(state, action) {
      state.dateTimeInMs = action.payload || Date.now();
    },

    storeEmployeeShiftData(state, action) {
      state.employeeShift = action.payload || [];
    },

    clearProvision(state) {
      state.provision = {};
    },

    clearCurrentFunctionKey(state) {
      state.currentFunctionKey = {};
    },

    clearCustomMappingData(state) {
      state.customMappingData = {};
    },
  },
});

export const {
  updateProvision,
  updateCurrentFunctionKey,
  storeShiftId,
  resetShiftId,
  storeDateAndTimeInMS,
  storeEmployeeShiftData,
  updateCustomMappingData,
  clearProvision,
  clearCurrentFunctionKey,
  clearCustomMappingData,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
